import getConfig from 'next/config';

import { IBank } from '../interfaces/organizations';
import client from '../utils/client';

interface IParams {
  ids?: number;
  statuses?: string;
  type?: string;
  limit?: number;
}

export const getBanksList = async (params: IParams): Promise<IBank[]> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/banks/`;
  const { data } = await client.get<IBank[]>(url, { params });

  return data ?? [];
};
